import { useEffect } from 'react';
import { NavBar } from '../components/NavBar';
import { HeroSection } from '../components/HeroSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { VerticalsSection } from '../components/VerticalsSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProductShowcase } from '../components/ProductShowcase';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { LeadCaptureSection } from '../components/LeadCaptureSection';
import { Footer } from '../components/Footer';

export function LandingPage() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' },
    );

    const els = document.querySelectorAll('.reveal');
    for (const el of els) {
      observer.observe(el);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0f0d] text-zinc-100">
      <NavBar />
      <HeroSection />
      <FeaturesSection />
      <VerticalsSection />
      <HowItWorksSection />
      <ProductShowcase />
      <TestimonialsSection />
      <PricingSection />
      <FAQSection />
      <CTASection />
      <LeadCaptureSection />
      <Footer />
    </div>
  );
}
